import { gql } from '@apollo/client';

export const getDomain = gql`
  query getDomain($domain: String!) {
    getDomain(domain: $domain) {
      id
      domain
      name
      currency
      languages {
        code
      }
      defaultLanguage {
        code
      }
    }
  }
`;

export const listCourses = gql`
  query listCourses(
    $pagination: PaginationInput
    $filter: CourseFilter
    $organizationId: ID
  ) {
    listCourses(
      pagination: $pagination
      filter: $filter
      organizationId: $organizationId
    ) {
      id
      name {
        languageCode
        languageId
        value
      }
      archivedScheduledAt
    }
  }
`;

export const listFeaturedCourses = gql`
  query listFeaturedCourses {
    listFeaturedCourses {
      id
      name {
        languageCode
        languageId
        value
      }
    }
  }
`;
